//import { EligibleExpenditureCategoryMilestoneReportModel } from '../../models/EligibleExpenditureCategoryMilestoneReportModel'
import { State } from './Model'

export type Action =
  | { type: 'add_row'; skipReset: boolean; data: any }
  | { type: 'update_cell';skipReset: boolean; data: any, rowIndex: number, columnId: string, value: string }
  | { type: 'remove_row';skipReset: boolean; data: any, rowIndex: number }
  | { type: 'enable_reset';skipReset: boolean }

export default function reducer(prevState: State, action: Action): State {
  switch (action.type) {
    case 'add_row':
      return {
        ...prevState,
        skipReset: true,
        data: [...prevState.data, {}],
      }
    case 'update_cell':
      return {
        ...prevState,
        skipReset: true,
        data: prevState.data.map((row: any, index: number) => {
          if (index === action.rowIndex) {
            return {
              ...prevState.data[action.rowIndex],
              [action.columnId]: action.value,
            }
          }
          return row
        }),
      }
    case 'remove_row':
      //action =  {type: 'remove_row', rowIndex:0 to n-1}
      return {
        ...prevState,
        skipReset: true,
        data: prevState.data.filter((row: any, index: number) => index !== action.rowIndex),
      }
    case 'enable_reset':
      return {
        ...prevState,
        skipReset: false,
      }
    default:
      return prevState
  }
}
